import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Avatar } from '@change-corgi/design-system-legacy/components/media';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import iconEmailSender from 'src/assets/icons/default_icon.png';

import type { PreviewEmailSenderInfoProps } from '../../../../types';

export function PreviewEmailSenderInfo({ userName }: PreviewEmailSenderInfoProps): JSX.Element {
	return (
		<Flex sx={{ alignContent: 'center' }} mb={40}>
			<Avatar src={iconEmailSender} alt={userName} size="s" mx="auto" my={0} />
			<Box pl={16} sx={{ flex: 1 }}>
				<Text as="p" fontWeight="bold" size="small" sx={{ fontFamily: 'Helvetica Neue' }}>
					<Translate
						value="fe.pages.petition_update_composer.preview.sender_info.sender_via_change_org"
						replacements={{ userName }}
					/>
				</Text>
				<Text as="p" size="small" sx={{ fontFamily: 'Helvetica Neue' }} color="neutral-grey700">
					<Translate value="fe.pages.petition_update_composer.preview.sender_info.to_me" />
				</Text>
			</Box>
		</Flex>
	);
}
